import { IApplicationState } from '../../types/redux';

export function selectPageKind(state: IApplicationState) {
  return state.page.kind;
}
